// @flow
import Types from '../actions/Types';
import Actions from '../actions/Creators';
import { put, call, takeLatest } from 'redux-saga/effects';

export default (api: Object) => {

    /* Get Dashboard */
    function* getDashboard(action) {
        try {
            const response = yield call(api.dashboard.getDashboard, action.durationValue, );

            if (response.ok && response.data && {}.hasOwnProperty.call(response, 'data')) {
                yield put(Actions.getDashboardSuccess( response.data));
            } else {
                yield put(Actions.getDashboardFailure(response.errorMessage));
            }
        } catch (error) {
            yield put(Actions.getDashboardFailure(error));
        }
    }
    function* watchGetDashboard(): Generator<void, void, void> {
        yield takeLatest(Types.GET_DASHBOARD, getDashboard);
    }

    return {
        watchGetDashboard
    };
};



// WEBPACK FOOTER //
// ./src/sagas/DashboardSaga.js